module.exports = __webpack_public_path__ + "img/Ansicht Leitstand1.9f81b887.jpg";